export const copyToClipboard = (value: string): void => {
    window.navigator.clipboard.writeText(value).catch((error) => {
        console.info("clipboard error:", error);
    });
};
